/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios';
import { Dialog } from 'vant';
import {
  getToken,
} from '@/utils/auth'
import { setToCodeUrl } from '@/utils/config';
import router from '@/router/router'
// import NProgress from 'nprogress';
// import 'nprogress/nprogress.css';

//默认超时时间
axios.defaults.timeout = 10000;
//返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
// NProgress 配置
// NProgress.configure({
//   showSpinner: false
// });
//http request拦截
axios.interceptors.request.use(config => {
  if (getToken() && !config.headers['noToken']) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  //开启 progress bar
  // NProgress.start();
  return config
}, error => {
  return Promise.reject(error)
});

// 响应拦截器
axios.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const errorCode = {
    '401': '认证失败，无法访问系统资源',
    '403': '当前操作没有权限',
    '404': '访问资源不存在',
    'default': '系统未知错误，请反馈给管理员'
  }
  const msg = errorCode[code] || res.data.msg || errorCode['default'];
  // 二进制数据则直接返回
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    return res.data
  }
  if (code === 401) {
    window.location.href = setToCodeUrl(`/login?redirect=${router.currentRoute.fullPath}`);
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
  } else if (code === 500 || code !== 200 || res.data.status === 403) {
    Dialog.alert({
      title: '友情提示',
      message: msg,
    }).then(() => {
      // on close
    });
    return Promise.reject(res.data)
  } else {
    return res.data
  }

},
  error => {
    return Promise.reject(error)
  }
)

export default axios;
